var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSequence = function SvgSequence(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_seq",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icn_seq-2",
    "data-name": "icn_seq",
    d: "M-665.1-396.994c0-.013,0-.027,0-.04s0-.013,0-.02,0-.015,0-.022,0-.017,0-.025,0-.007,0-.011a.518.518,0,0,0-.164-.342.523.523,0,0,0-.594-.083l0,0-.011.006-.007,0-15.634,8.165a.524.524,0,0,0-.278.5.524.524,0,0,0,.352.454l5.733,1.96v4.329a.522.522,0,0,0,.36.5.521.521,0,0,0,.162.026.525.525,0,0,0,.421-.212l2.535-3.45,4.528,1.548a.534.534,0,0,0,.168.028.519.519,0,0,0,.271-.076.521.521,0,0,0,.246-.369l1.912-12.865h0Zm-2.977,1.8-7.252,7.779L-679.948-389Zm-6.583,11.492v-2.382l1.4.478Zm6.706-1.192-6.292-2.151,7.867-8.438Z",
    transform: "translate(702.441 487.593)",
    fill: "#8d8d8d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSequence, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sequence.a0027c3c.svg";
export { ForwardRef as ReactComponent };